<template>
  <section class="relative overflow-hidden py-10 bg-gray-50 min-h-screen">
    <div class="container mx-auto px-6">
      <div class="text-center">
        <h3 class="mt-8 text-2xl font-semibold text-blue-600">
          Özel adres Seçildi!
        </h3>
        <p class="mt-2 text-lg font-medium text-gray-800">
          {{ getStatusHeadingText }}
        </p>
      </div>

      <div class="bg-white shadow-lg rounded-lg p-8">
        <div class="status-container mb-6">
          <div class="flex items-center">
            <div class="status-circle bg-blue-500 text-white">
              <i class="fas fa-check"></i>
            </div>
            <div class="status-line bg-blue-500"></div>
            <div
              class="status-circle text-white"
              :class="[
                panelStatus === 'SUCCESSFUL'
                  ? 'bg-blue-500'
                  : 'bg-blue-500 pulse-animation',
              ]"
            >
              <i
                :class="
                  panelStatus === 'SUCCESSFUL' ? 'fas fa-check' : 'fas fa-cog'
                "
              ></i>
            </div>
            <div
              class="status-line"
              :class="
                panelStatus === 'SUCCESSFUL' ? 'bg-blue-500' : 'bg-grey-300'
              "
            ></div>
            <div
              class="status-circle"
              :class="
                panelStatus === 'SUCCESSFUL'
                  ? 'bg-blue-500 text-white'
                  : 'bg-gray-300'
              "
            >
              <i class="fas fa-check"></i>
            </div>
          </div>
          <div class="flex justify-between text-sm text-gray-600 mt-2">
            <span>Özel adres Seçildi</span>
            <span>Hazırlanıyor</span>
            <span>Tamamlandı</span>
          </div>
        </div>

        <div class="space-y-6">
          <div class="p-4 bg-blue-50 rounded-lg border border-blue-100">
            <h4 class="font-medium text-blue-700">Süreç Hakkında Bilgi</h4>
            <ul class="mt-3 space-y-4 text-gray-700">
              <li class="flex items-start">
                <span
                  class="inline-flex items-center justify-center mr-3 mt-0.5 w-5 h-5 bg-blue-500 rounded-full flex-shrink-0"
                >
                  <span class="text-xs text-white">1</span>
                </span>
                <span>
                  &nbsp; Panel hazırlanması <b>5-10 dakika</b> arasında
                  sürebilir.</span
                >
              </li>
              <li class="flex items-start">
                <span
                  class="inline-flex items-center justify-center mr-3 mt-0.5 w-5 h-5 bg-blue-500 rounded-full flex-shrink-0"
                >
                  <span class="text-xs text-white">2</span>
                </span>
                <span
                  >&nbsp; Süreç tamamlandığında <b>giriş bilgileriniz</b> ve
                  paneliniz ile ilgili e-posta ile bilgilendirme
                  yapılacak.</span
                >
              </li>
              <li class="flex items-start">
                <span
                  class="inline-flex items-center justify-center mr- mt-0.5 w-5 h-5 bg-blue-500 rounded-full flex-shrink-0"
                >
                  <span class="text-xs text-white">3 </span>
                </span>
                <span
                  >&nbsp; Bu süreç içerisinde herhangi bir soru ya da sorununuz
                  olursa lütfen <b>Destek Taleplerim</b> ekranından bizimle
                  iletişime geçmekten çekinmeyin.</span
                >
              </li>
              <li class="flex items-start">
                <span
                  class="inline-flex items-center justify-center mr-3 mt-0.5 w-5 h-5 bg-blue-500 rounded-full flex-shrink-0"
                >
                  <span class="text-xs text-white">4</span>
                </span>
                <span
                  >&nbsp; Bu ekranın açık kalmasına gerek yoktur, biz işlemleri
                  tamamlayınca size bilgi vereceğiz.</span
                >
              </li>
            </ul>
          </div>

          <div class="border-t pt-6">
            <h4 class="font-medium text-gray-700 mb-4">Yasal Dokümanlarımız</h4>
            <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
              <a
                :href="kvkk"
                class="flex items-center p-3 border rounded-lg hover:bg-gray-50 transition-colors"
              >
                <span
                  class="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-blue-500 mr-3"
                >
                  <i class="fas fa-file-alt"></i>
                </span>
                <span class="text-gray-700">KVKK</span>
              </a>
              <a
                :href="userAgreement"
                class="flex items-center p-3 border rounded-lg hover:bg-gray-50 transition-colors"
              >
                <span
                  class="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-blue-500 mr-3"
                >
                  <i class="fas fa-file-contract"></i>
                </span>
                <span class="text-gray-700">Kullanıcı Sözleşmesi</span>
              </a>
              <a
                :href="dataProtection"
                class="flex items-center p-3 border rounded-lg hover:bg-gray-50 transition-colors"
              >
                <span
                  class="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-blue-500 mr-3"
                >
                  <i class="fas fa-shield-alt"></i>
                </span>
                <span class="text-gray-700">Veri Güvenliği</span>
              </a>
              <a
                :href="privacyPolicy"
                class="flex items-center p-3 border rounded-lg hover:bg-gray-50 transition-colors"
              >
                <span
                  class="w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 text-blue-500 mr-3"
                >
                  <i class="fas fa-user-secret"></i>
                </span>
                <span class="text-gray-700">Gizlilik Politikası</span>
              </a>
            </div>
          </div>

          <div class="mt-8 text-center">
            <router-link
              to="/user/subscriptions"
              class="inline-flex items-center py-3 px-6 bg-blue-500 text-white font-medium rounded-lg shadow-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 transition-colors"
            >
              <i class="fas fa-arrow-left mr-2"></i>
              Aboneliklerime Dön
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted, computed, onUnmounted } from "vue";
import { useRoute } from "vue-router";
import { getPanelStatus } from "@/services/userServices";
import { fetchLegalDocuments } from "@/services/contentService";

const route = useRoute();
// subscriptionId is in path params
const subscriptionId = ref(route.params.subscriptionId);
const panelStatus = ref("IN_PROGRESS");
const intervalId = ref(null);
const kvkk = ref("");
const userAgreement = ref("");
const privacyPolicy = ref("");
const dataProtection = ref("");

const getStatusHeadingText = computed(() => {
  if (panelStatus.value === "SUCCESSFUL") {
    return "Paneliniz Hazır!";
  } else if (panelStatus.value === "FAILED") {
    return "Panel hazırlanırken bir sorun oluştu.";
  } else if (panelStatus.value === "PENDING") {
    return "Paneliniz hazırlanmak için sırada bekliyor...";
  } else {
    return "Paneliniz hazırlanıyor...";
  }
});

onMounted(() => {
  window.scrollTo(0, 0);
  checkPanelStatus(true);
  intervalId.value = setInterval(checkPanelStatus, 10000); // Her 10 saniyede bir durumu kontrol et

  fetchLegalDocuments().then((documents) => {
    kvkk.value = documents.Kvkk || "";
    userAgreement.value = documents.UserAgreement || "";
    privacyPolicy.value = documents.DataProtection || "";
    dataProtection.value = documents.PrivacyPolicy || "";
  });
});

onUnmounted(() => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
  }
});

const checkPanelStatus = async (isFirstCheck = false) => {
  // Sadece ilk kontrolde veya durumu henüz tamamlanmamışsa kontrol edelim
  if (
    isFirstCheck ||
    ["IN_PROGRESS", "PENDING", "FAILED"].includes(panelStatus.value)
  ) {
    const response = await getPanelStatus(subscriptionId.value * 1);

    if (response && response.MigrationStatus) {
      panelStatus.value = response.MigrationStatus;

      // Eğer işlem başarıyla tamamlandıysa, otomatik kontrolleri durduralım
      if (response.MigrationStatus === "SUCCESSFUL") {
        clearInterval(intervalId.value);
      }
    }
  }
};
</script>

<style scoped>
.container {
  max-width: 720px;
}

.animation-container {
  height: 80px;
  width: 120px;
}

.bg-gray-300 {
  background-color: #e2e8f0;
}
.bg-gray-50 {
  background-color: #f9fafb;
}

.rocket-animation {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  animation: rocketAnimation 3s ease-in-out infinite;
}

.gear-animation {
  position: absolute;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
}

.gear {
  position: absolute;
}

.gear-1 {
  left: -20px;
  animation: rotateGear 4s linear infinite;
}

.gear-2 {
  right: -20px;
  animation: rotateGearReverse 4s linear infinite;
}

@keyframes rocketAnimation {
  0%,
  100% {
    transform: translateX(-50%) translateY(0);
  }
  50% {
    transform: translateX(-50%) translateY(-10px);
  }
}

@keyframes rotateGear {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes rotateGearReverse {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

.status-container {
  width: 100%;
  margin: 0 auto;
}

.status-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.status-line {
  flex-grow: 1;
  height: 2px;
  margin: 0 -2px;
}

.pulse-animation {
  animation: pulse 1.5s ease-in-out infinite;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}
</style>
